import axios from 'axios'
import type { GetMccGroupListResponse } from 'src/models/mccGroup.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export interface GetMccGroupsOptions {
  includeRanges?: boolean
}

export const getMccGroups = async <
  TResponse extends GetMccGroupListResponse = GetMccGroupListResponse,
>(
  options: GetMccGroupsOptions = {},
): Promise<TResponse> => {
  const requestConfig = getRequestConfig(RequestConfig.Default)
  const config = options.includeRanges
    ? {
        ...requestConfig,
        params: { ...requestConfig.params, includeRanges: true },
      }
    : requestConfig

  return getResponseData(axios.get<TResponse>(`/mccgroups`, config))
}
